<script setup>
import { ref, computed } from 'vue';
import ResizableTextArea from 'shared/components/ResizableTextArea.vue';
import Avatar from 'next/avatar/Avatar.vue';
import FluentIcon from 'shared/components/FluentIcon/Index.vue';

const props = defineProps({
  config: {
    type: Object,
    default: () => ({}),
  },
});

const isInputFocused = ref(false);

const showReplyTime = computed(() => {
  return props.config.replyTime !== '';
});
</script>

<template>
  <div class="relative flex flex-col w-full px-4">
    <div v-if="config.isDefaultScreen">
      <button
        v-if="config.isDefaultScreen"
        class="p-6 shadow hover:shadow-xl rounded-xl w-full flex flex-row items-center justify-between border"
        :style="{
          color: 'var(--wt-primary, ' + config.color + ')',
          background: 'var(--wt-input-bg, #ffffff)',
          borderColor: 'var(--wt-border-color, #e0e6ed)',
        }"
      >
        <div class="flex flex-col">
          <span
            class="text-xl text-left font-semibold"
            :style="{ color: 'var(--wt-input-text, #3c4858)' }"
          >
            {{
              $t(
                'INBOX_MGMT.WIDGET_BUILDER.FOOTER.START_CONVERSATION_BUTTON_TEXT'
              )
            }}
          </span>
          <div
            v-if="showReplyTime"
            class="mt-1 text-xs"
            :style="{ color: 'var(--wt-muted-text, #3c4858)' }"
          >
            {{ config.replyTime }}
          </div>
        </div>
        <FluentIcon icon="arrow-right" size="24" />
      </button>
    </div>
    <div
      v-else
      class="flex items-center h-10 rounded-md border"
      :class="{ 'ring-2 ring-n-brand dark:ring-n-brand': isInputFocused }"
      :style="{
        background: 'var(--wt-input-bg, #ffffff)',
        borderColor: 'var(--wt-border-color, #e0e6ed)',
      }"
    >
      <ResizableTextArea
        id="chat-input"
        :rows="1"
        :placeholder="
          $t('INBOX_MGMT.WIDGET_BUILDER.FOOTER.CHAT_INPUT_PLACEHOLDER')
        "
        class="reset-base flex-grow border-0 outline-none !outline-0 border-none h-8 text-sm pb-0 !pt-1.5 resize-none px-3 !mb-0 focus:outline-none rounded-md"
        :style="{
          background: 'var(--wt-input-bg, #ffffff)',
          color: 'var(--wt-input-text, #3c4858)',
        }"
        @focus="isInputFocused = true"
        @blur="isInputFocused = false"
      />
      <div class="flex items-center gap-2 px-2">
        <FluentIcon icon="emoji" />
        <FluentIcon class="icon-send" icon="send" />
      </div>
    </div>
  </div>
</template>
